import React from 'react';
import heroRoad from '../assets/intertown-hero-road.webp';
import { IconPin, IconRupee, IconShield } from './IntertownIcons';

const Chip = ({ icon, children }) => (
  <span className="it2-chip"><span className="it2-chip-ico">{icon}</span>{children}</span>
);

const Banner = ({ t }) => (
  <section className="it2-hero">
    <img className="it2-hero-art" src={heroRoad} alt="" />
    <div className="it2-hero-text">
      <h2>{t('intertown.heroTitle')}</h2>
      <p>{t('intertown.heroBody')}</p>
    </div>
    <div className="it2-chips">
      <Chip icon={<IconRupee size={12} />}>{t('intertown.fixedFare')}</Chip>
      <Chip icon={<IconPin size={12} />}>{t('intertown.chipLiveTracking')}</Chip>
      <Chip icon={<IconShield size={12} />}>{t('intertown.chipVerifiedAnna')}</Chip>
    </div>
  </section>
);

/**
 * Page title, plus the banner with the three trust chips. The banner is a booking
 * pitch, so a caller that has no use for it can hide it with showBanner={false}.
 * (A trip under way is not drawn on this page at all: IntertownTripScreen takes over.)
 */
export default function IntertownHero({ t, showBanner = true }) {
  return (
    <>
      <h1 className="it2-title">{t('intertown.pageTitle')}</h1>
      {showBanner && <Banner t={t} />}
    </>
  );
}
